import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Divider, Typography } from '@mui/material';

import { Post } from '@libs/models';
import { usePostSearchQuery } from '@carcareers/store';
import {
  RunCronButton,
  DataGridV2 as DataGrid,
  DashboardPageContainer,
} from '@carcareers/components';
import { useDrawer } from '@carcareers/contexts';
import { ADMIN_POST_INDEX_COLUMNS, ADMIN_POST_INDEX_COLUMN_INITIAL_STATE, routes } from '@carcareers/utils';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Edit, Visibility } from '@mui/icons-material';

export const PostIndex: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const search = usePostSearchQuery;
  const { setOpen } = useDrawer();

  const columns = [
    ...ADMIN_POST_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_POSTS_VIEW.replace(':id', params.row.id.toString())}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`edit-${params.row.id}`}
          label="Edit Template"
          icon={<Edit />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBS_VIEW.replace(':id', params.row.job.id.toString())}`)
          }
        />,
      ],
    },
  ];

  useEffect(() => {
    if (searchParams.get('new')) {
      setOpen(true);
    }
  }, [searchParams, setOpen]);

  return (
    <DashboardPageContainer>
      <DataGrid<Post>
        columns={columns}
        query={search}
        initialState={{
          columns: {
            columnVisibilityModel: ADMIN_POST_INDEX_COLUMN_INITIAL_STATE,
          },
        }}
        tools={
          <>
            <Button
              onClick={() => navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_POSTS_ADD}`)}
              variant="contained"
              color="primary"
            >
              Add
            </Button>
            <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
          </>
        }
        actions={
          <>
            <Typography variant="caption" sx={{ color: 'error.main' }}>
              Be very careful what you do on this page. This will charge customers if you mess with the auto-renewal.
            </Typography>
            <RunCronButton />
          </>
        }
      />
    </DashboardPageContainer>
  );
};

export default PostIndex;
